/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerNavBarDropMenuSX: SxProps = {
	borderTopRightRadius: 0,
	borderTopLeftRadius: 0,
	maxWidth: '100%',
	width: '100%',
	boxShadow: 0,
	backgroundColor: 'background.paper',
	color: 'background.contrastText',
	'@media (hover: hover)': {
		py: 0,
		px: 1,
	},

	'.MuiTooltip-popper[data-popper-placement*="bottom"] > &': {
		'@media (hover: hover)': {
			mt: 0,
			ml: 0,
			width: '100%',
			transition: 'none !important',
			maxHeight: '800px',
			// transition: 'transform 0.5s, opacity 0.5s !important',
			// transition:
			// 'opacity 500ms cubic-bezier(0.4, 0, 0.2, 1), transform 300ms cubic-bezier(0.4, 0, 0.2, 1) !important',
		},
		'@media (hover: none)': {
			margin: '0px !important',
		},
	},
};
